import {ChangeDetectionStrategy, Component, EventEmitter, inject, OnInit} from '@angular/core';
import {NbButtonModule, NbIconModule, NbInputModule, NbSpinnerModule, NbWindowService} from '@nebular/theme';
import {BaseFieldType, CatalogWithAncestors} from 'compob2b-libs';
import {catchError, share, take, takeUntil, tap} from 'rxjs/operators';
import {translations} from '../../../../environments/translations.ru';
import {ChooseCatalogModalComponent} from '../../choose-catalog-modal/choose-catalog-modal.component';
import {CatalogService} from '../../../cabinet/pim/catalog/catalog.service'
import {FormlyValidationMessage} from '@ngx-formly/core'
import {NgIf} from '@angular/common'

@Component({
  templateUrl: './catalog-picker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `[nbInput] {
    max-width: 800px
  }`,
  imports: [
    NbSpinnerModule,
    NbIconModule,
    NbButtonModule,
    FormlyValidationMessage,
    NgIf,
    NbInputModule
  ]
})
export class CatalogPickerComponent extends BaseFieldType implements OnInit {
  catalog: CatalogWithAncestors = null;
  catalogChosenEvent: EventEmitter<CatalogWithAncestors> = new EventEmitter<CatalogWithAncestors>();

  catalogService = inject(CatalogService);
  windowService = inject(NbWindowService);

  get excludeCatalogIds() {
    return this.props['excludeCatalogIds'] ?? [];
  }

  ngOnInit(): void {
    this.formControl.valueChanges
      .pipe(
        catchError(err => this.handleError(err)),
        takeUntil(this.unsubscribe),
        tap(catalogID => {
          if (!catalogID) {
            this.catalog = null;
          } else if (this.catalog?.id !== catalogID) {

            this.loading = true;

            this.compoApiService.get<CatalogWithAncestors>(`${this.catalogService.apiUrl}/${catalogID}/with-ancestors`)
              .pipe(
                catchError(err => this.handleError(err)),
                share(),
                take(1),
                tap(response => {
                  this.catalog = response.data;
                  this.loading = false;
                  this.cdr.detectChanges();
                }),
              ).subscribe();
          }
        }),
      )
      .subscribe();

    this.catalogChosenEvent
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(catalog => this.select(catalog));
  }

  getOptionLabel(catalog: CatalogWithAncestors): string {
    console.log(catalog);

    return catalog ? catalog.ancestors.filter(item => item !== null).concat(catalog.header).join(' > ') : '';
  }

  openChooseCatalogModal(): void {
    this.formControl.markAsTouched();

    this.windowService.open(ChooseCatalogModalComponent, {
      context: {
        catalogService: this.catalogService,
        onlyOneSelection: true,
        catalogChosenEvent: this.catalogChosenEvent,
        chooseOnlyLastLevel: this.field.props.chooseOnlyLastLevel === undefined || this.field.props.chooseOnlyLastLevel,
        chosenCatalog: this.catalog,
        excludeCatalogIds: this.excludeCatalogIds,
      },
      title: translations.selectOneCatalog
    });
  }

  select(chosenCatalog: CatalogWithAncestors | null) {
    this.formControl.setValue(chosenCatalog ? chosenCatalog.id : (this.field?.defaultValue || null));
    this.formControl.markAsTouched();
    this.cdr.detectChanges();
  }

}
